import React from 'react'
import { SESSION_INTERFACE_IDS } from '../../domain'
import { FLOW_TYPES } from '../../providerIds'
import {
  readLocalParticipantIdentity,
  readSessionInterfaceId,
} from '../../session'
import SharedRtcVideoSurface from './SharedRtcVideoSurface'

export default function AuditAgoraVideoSurface({
  sessionBootstrap = null,
  sessionRoutingDecision = null,
  rtcProps,
  rtmProps,
  callbacks = {},
  fallback = null,
  onCameraClose,
  onCameraOpen,
  onAudioClose,
  onAudioOpen,
}) {
  const localParticipantIdentity = React.useMemo(
    () => readLocalParticipantIdentity(sessionBootstrap, null),
    [sessionBootstrap],
  )
  const sessionInterfaceId = React.useMemo(
    () => readSessionInterfaceId(sessionBootstrap, FLOW_TYPES.auditSession),
    [sessionBootstrap],
  )

  return (
    <SharedRtcVideoSurface
      sessionRoutingDecision={sessionRoutingDecision}
      agoraRtcProps={rtcProps}
      agoraRtmProps={rtmProps}
      handleLeaveRoom={callbacks?.EndCall || (() => {})}
      localParticipantIdentity={localParticipantIdentity}
      sessionInterfaceId={sessionInterfaceId || SESSION_INTERFACE_IDS.auditObserver}
      onCameraClose={onCameraClose}
      onCameraOpen={onCameraOpen}
      onAudioClose={onAudioClose}
      onAudioOpen={onAudioOpen}
      playAudioOnUserJoin={false}
      playAudioOnUserLeave={false}
      providerFallback={fallback}
    />
  )
}

AuditAgoraVideoSurface.displayName = 'AuditAgoraVideoSurface'
